import { useMemo } from "react";
import useAbacAccess from "./useAbacAccess";

/**
 * Shared User-module ABAC leaf gates (multi-access only; fail-open).
 * Paths: canAccess("user", area, leaf) - see adminAbacSchema.json "user".
 */
export default function useUserModuleAbac() {
  const { canAccess, shouldEnforce } = useAbacAccess();

  return useMemo(
    () => ({
      shouldEnforce,

      canBlockUser: canAccess("user", "block_user"),
      canUnblockUser: canAccess("user", "unblock_user"),
      canViewFlagStatus: canAccess("user", "view_flag_status"),
      canViewMobileEmail: canAccess("user", "view_mobile_email"),
      canViewWebAccessLog: canAccess("user", "web_access_log", "view"),

      canViewProfile: canAccess("user", "profile", "view"),
      canCreateProfile: canAccess("user", "profile", "create"),
      canUpdateProfile: canAccess("user", "profile", "update"),
      canDeleteProfile: canAccess("user", "profile", "delete"),

      canUpdateFlag: canAccess("user", "flag", "update"),

      canViewConfiguration: canAccess("user", "configuration", "view"),
      canUpdateConfiguration: canAccess("user", "configuration", "update"),

      canViewSession: canAccess("user", "session", "view"),

      canUpdateBalance: canAccess("user", "balance", "update"),

      canViewBlockStatus: canAccess("user", "block_status", "view"),

      canViewToken: canAccess("user", "token", "view"),
      canGenerateToken: canAccess("user", "token", "generate"),
      canRegenerateToken: canAccess("user", "token", "regenerate"),

      canViewTransactionMode: canAccess("user", "transaction_mode", "view"),
      canUpdateTransactionMode: canAccess("user", "transaction_mode", "update"),

      canViewMultiAccess: canAccess("user", "multi_access", "view"),
      canCreateMultiAccess: canAccess("user", "multi_access", "create"),
      canUpdateMultiAccess: canAccess("user", "multi_access", "update"),
      canDeleteMultiAccess: canAccess("user", "multi_access", "delete"),

      canViewLimit: canAccess("user", "limit", "view"),
      canCreateLimit: canAccess("user", "limit", "create"),
      canUpdateLimit: canAccess("user", "limit", "update"),
      canDeleteLimit: canAccess("user", "limit", "delete"),

      canViewUserTemplates: canAccess("user", "user_templates", "view"),
      canCreateUserTemplates: canAccess("user", "user_templates", "create"),
      canUpdateUserTemplates: canAccess("user", "user_templates", "update"),
      canDeleteUserTemplates: canAccess("user", "user_templates", "delete"),

      canViewHlrSchedule: canAccess("user", "hlr_schedule", "view"),
      canCreateHlrSchedule: canAccess("user", "hlr_schedule", "create"),
      canUpdateHlrSchedule: canAccess("user", "hlr_schedule", "update"),
      canDeleteHlrSchedule: canAccess("user", "hlr_schedule", "delete"),
    }),
    [canAccess, shouldEnforce]
  );
}
